import { Button, Drawer, Form, Input, InputNumber, Select, Space } from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../context";

const CommissaryRawEdit = ({
  open,
  close,
  setLoading,
  getRawProductList,
  selectedData,
  unitList,
  categoryList,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const [form] = Form.useForm();

  // console.log("selectedData", selectedData);

  const handleEditRawProduct = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", selectedData !== null ? selectedData.id : "");
    formdata.append("raw_id", selectedData !== null ? selectedData.raw_id : "");
    formdata.append(
      "commissary_id",
      selectedData !== null ? selectedData.commissary_id : ""
    );

    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);
    setLoading(true);
    axios
      .post("user/commissary/edit-raw-product", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Edited raw product successfully.");
          setTimeout(() => {
            close();
            form.setFieldsValue({
              is_production: "",
              sku: "",
              product: "",
              description: "",
              unit: "",
              category: "",
              purchase_price: "",
              msrp: "",
              srp: "",
            });
            setLoadings(false);
            setLoading(false);
            getRawProductList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Edit Raw Product"
      // width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      {selectedData !== null && (
        <Form
          form={form}
          layout="vertical"
          name="basic"
          initialValues={{
            is_production: selectedData.is_production,
            sku: selectedData.sku,
            product: selectedData.product,
            description: selectedData.description,
            unit: parseInt(selectedData.unit),
            category: parseInt(selectedData.category),
            purchase_price: selectedData.purchase_price,
            msrp: selectedData.msrp,
            srp: selectedData.srp,
          }}
          onFinish={handleEditRawProduct}
          autoComplete="off"
        >
          <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
            <Form.Item
              name="is_production"
              label="For Production?"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select"
                size="large"
                showSearch
                // onChange={(e) => console.log("QWE", e)}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                <Select.Option value={0}>No</Select.Option>
                <Select.Option value={1}>Yes</Select.Option>
              </Select>
            </Form.Item>

            <Form.Item
              name="sku"
              label="SKU"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Input placeholder="Set SKU" size="large" />
            </Form.Item>

            <Form.Item
              name="product"
              label="Raw Product Name"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Input placeholder="Set product name" size="large" />
            </Form.Item>

            <Form.Item
              name="description"
              label="Raw Product Description"
              rules={[
                {
                  required: false,
                  message: "Required",
                },
              ]}
            >
              <Input placeholder="Set product description" size="large" />
            </Form.Item>

            <Form.Item
              name="unit"
              label="Raw Unit Per Consumption"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select unit"
                size="large"
                showSearch
                // onChange={(e) => console.log("QWE", e)}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {unitList.data.length > 0 ? (
                  unitList.data.map((data, index) => (
                    <Select.Option value={data.id} key={index}>
                      {data.unit}
                    </Select.Option>
                  ))
                ) : (
                  <Select.Option value="">No unit found!</Select.Option>
                )}
              </Select>
            </Form.Item>

            <Form.Item
              name="category"
              label="Raw Category"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select category"
                size="large"
                showSearch
                // onChange={(e) => console.log("QWE", e)}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {categoryList.data.length > 0 ? (
                  categoryList.data.map((data, index) => (
                    <Select.Option value={data.id} key={index}>
                      {data.category}
                    </Select.Option>
                  ))
                ) : (
                  <Select.Option value="">No category found!</Select.Option>
                )}
              </Select>
            </Form.Item>

            <Form.Item
              name="purchase_price"
              label="Purchase Price Per Consumption"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <InputNumber
                min={0}
                max={999999999999}
                initialvalues={0}
                size="large"
                style={{ width: "100%" }}
                step="0.01"
              />
            </Form.Item>

            <Form.Item
              name="msrp"
              label="Raw Product MSRP Per Consumption"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <InputNumber
                min={0}
                max={999999999999}
                initialvalues={0}
                size="large"
                style={{ width: "100%" }}
                step="0.01"
              />
            </Form.Item>

            <Form.Item
              name="srp"
              label="Raw Product SRP Per Consumption"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <InputNumber
                min={0}
                max={999999999999}
                initialvalues={0}
                size="large"
                style={{ width: "100%" }}
                stringMode
                step="0.01"
              />
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loadings}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loadings ? "Loading" : "Update"}
            </Button>
          </Form.Item>
        </Form>
      )}
    </Drawer>
  );
};

export default CommissaryRawEdit;
